import React from 'react';
import { getFaIcon } from '@odin-labs/components';
import { cn } from 'utils';

const classes = {
  badgeInfoItem: cn(
    'badge-info-item-container',
    'odin-flex',
    'odin-items-center',
    'odin-text-gray-900 odin-text-sm',
    'odin-truncate',
  ),
  badgeInfoItemIcon: cn(
    'badge-info-item-icon',
    'odin-text-odin-primary',
    'odin-text-base',
    'odin-font-normal',
    'odin-mr-1.5',
  ),
};

export interface BadgeInfoItemProps {
  icon: ReturnType<typeof getFaIcon>;
  text: string;
}

export function BadgeInfoItem(props: BadgeInfoItemProps): React.ReactElement {
  const { icon: Icon, text = null } = props;
  return (
    text && (
      <div className={classes.badgeInfoItem}>
        <Icon className={classes.badgeInfoItemIcon} />
        {text}
      </div>
    )
  );
}
